import React from 'react'

import {TERMS_OF_SERVICE_URL} from '../../constants'
import {LegalPageView} from '../LegalPageView/LegalPageView'
import copy from './copy.json'

export const TermsOfServiceView: React.FC<React.PropsWithChildren> = () => {
  return (
    <LegalPageView
      heading={copy.heading}
      intro={copy.intro}
      src={TERMS_OF_SERVICE_URL}
      iframeTitle={copy.iframeTitle}
    />
  )
}
